var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#CCC",
    viewBox: "0 0 22 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.8h21.2v20.4H0V6.8zM3 0h15.2c1.7 0 3 1.3 3 3v2H0V3c0-1.7 1.3-3 3-3zm15.2 34H3c-1.7 0-3-1.3-3-3v-2h21.2v2c0 1.7-1.3 3-3 3zm-9.3-3.5c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h3.5c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1H8.9z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
export default SvgIconMobile;